import clsx from 'clsx'

const CheckboxFilledIcon = ({
	size = 'large',
	isInactive = false,
	...props
}: {
	size: 'small' | 'large'
	isInactive?: boolean
}) => (
	<svg
		width={size === 'small' ? 16 : 24}
		height={size === 'small' ? 16 : 24}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<g clipPath="url(#clip0_314_8050)">
			<rect
				width="24"
				height="24"
				rx="6"
				className={clsx(
					isInactive
						? 'fill-textInactiveLight dark:fill-grey900'
						: 'fill-textPrimaryLight dark:fill-textPrimaryDark',
				)}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M18.3536 8.35355C18.5488 8.54882 18.5488 8.8654 18.3536 9.06066L10.3536 17.0607C10.1583 17.2559 9.84171 17.2559 9.64645 17.0607L5.64645 13.0607C5.45118 12.8654 5.45118 12.5488 5.64645 12.3536L6.35355 11.6464C6.54882 11.4512 6.8654 11.4512 7.06066 11.6464L10 14.5858L16.9393 7.64645C17.1346 7.45118 17.4512 7.45118 17.6464 7.64645L18.3536 8.35355Z"
				className={clsx(
					isInactive
						? 'fill-textSecondaryLight dark:fill-textSecondaryDark'
						: 'fill-textPrimaryDark dark:fill-textPrimaryLight',
				)}
			/>
		</g>
		<defs>
			<clipPath id="clip0_314_8050">
				<rect width="24" height="24" rx="6" fill="white" />
			</clipPath>
		</defs>
	</svg>
)

export default CheckboxFilledIcon
